import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import {MatChipsModule, MatChipSet} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {FilterService} from '../../../services/filter.service';
import {CurrentSelectionDisplay} from '../../../models/current-selection-display';

@Component({
  selector: 'app-filter-current-selections-display',
  templateUrl: './filter-current-selections-display.component.html',
  styleUrls: ['./filter-current-selections-display.component.scss'],
  standalone: true,
  imports: [MatChipsModule, MatIconModule],
})
export class FilterCurrentSelectionsDisplayComponent implements OnInit {
  filterService = inject(FilterService);

  @Output() overflowingChips: EventEmitter<
    CurrentSelectionDisplay[]
  > = new EventEmitter<CurrentSelectionDisplay[]>();
  @ViewChild(MatChipSet, {read: ElementRef})
  MatChipSet: ElementRef<HTMLElement>;
  currentSelectionsDisplay: CurrentSelectionDisplay[];

  ngOnInit(): void {
    this.currentSelectionsDisplay = this.filterService.currentSelectionsAsChipDisplay;
    this.filterService.currentSelectionsChange$.subscribe(() => {
      this.currentSelectionsDisplay = this.filterService.currentSelectionsAsChipDisplay;
      this.setOverflowingChips();
    });
  }

  // In the future if we don't want the overflow to have all selections and only the ones
  // that don't fit. Need to implement the logic based on the chip elements overflow
  private setOverflowingChips(): void {
    // this.overflowingChips.next(this.atlasChipListElement?.nativeElement?.scrollHeight > 40);
    this.overflowingChips.emit(this.currentSelectionsDisplay);
  }
}
